import * as React from 'react';
//import Dropdown from 'react-dropdown'
//import 'react-dropdown/style.css'
import '../../sass/DecisionComponent.css';
import AppUtils from '../../utils/AppUtils';
import { Dropdown, DropdownButton, MenuItem, InputGroup, FormControl, FormGroup, Glyphicon, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Icon } from 'react-icons-kit';

// import {checkmark} from 'react-icons-kit/icomoon/checkmark'
// import {cross} from 'react-icons-kit/icomoon/cross'
// import {shuffle} from 'react-icons-kit/icomoon/shuffle'

import {neutral} from 'react-icons-kit/icomoon/neutral'

// Positive
import {cool2} from 'react-icons-kit/icomoon/cool2'
import {wink2} from 'react-icons-kit/icomoon/wink2'
import {smile2} from 'react-icons-kit/icomoon/smile2'
import {happy2} from 'react-icons-kit/icomoon/happy2'
import {grin2} from 'react-icons-kit/icomoon/grin2'

// Negative
import {tongue2} from 'react-icons-kit/icomoon/tongue2'
import {sad2} from 'react-icons-kit/icomoon/sad2'
import {crying2} from 'react-icons-kit/icomoon/crying2'
import {angry2} from 'react-icons-kit/icomoon/angry2'
import {frustrated2} from 'react-icons-kit/icomoon/frustrated2'

import {ic_directions_walk} from 'react-icons-kit/md/ic_directions_walk'
// import {man} from 'react-icons-kit/icomoon/man'
// import {man} from 'react-icons-kit/entypo/man'
import {man} from 'react-icons-kit/ionicons/man'
import AppConfig from '../../config/AppConfig';
import States from 'src/objects/States';
import Story from 'src/objects/Story';

// import {ic_thumb_up} from 'react-icons-kit/md/ic_thumb_up'
// import {ic_thumb_down} from 'react-icons-kit/md/ic_thumb_down'
// import {ic_thumbs_up_down} from 'react-icons-kit/md/ic_thumbs_up_down'


export default class DecisionComponent extends React.Component<any, any> {

    private text:string = this.props.text;
    private linkUrl:string = this.props.linkUrl;

    constructor(props: any) {
        super(props);
        //decisionList = this.props.decisions;
        //let decisionList = [];

        // let storyTitles:Array<string> = this.props.storys.map((a:any) => a.text);
        // console.log(storyTitles);

        this.state = {
            jumpStorySelected: "Choose page to jump to",
            jumpContinueDefaultOption: 0,
            jumpDefaultOption: 0,
            decisionText: this.text,
            linkUrl: this.linkUrl,
        }

        this.handleDecisionChange = this.handleDecisionChange.bind(this);
        this.handleLinkChange = this.handleLinkChange.bind(this);
    }

    private getCurrentChapterJump():string {
        if (this.props.jumpChapter == States.link || this.props.jumpChapter == States.backAStep || this.props.jumpChapter == States.gameOverFail || this.props.jumpChapter == States.nextChapter || this.props.jumpChapter == States.gameOverSuccess || this.props.jumpChapter == States.restart) {
            return this.props.jumpChapter
        }
        // if (this.props.jumpPage != null) {
            // console.log("--------")
            // console.log(this.props.chapters);
            // console.log("--------")
            let jumpChapter = this.props.jumpChapter;
            // if (jumpChapter == null || jumpChapter == undefined) {
            //     jumpChapter = this.props.currentChapter; // set it to the currentChapter by default
            // }
            let i:number = AppUtils.getChapterIndex(this.props, jumpChapter)
            if(this.props.chapters[i] == null) {
                i = 0; // default to the first chapter
            }
            //let text:string = this.truncateString(this.props.chapters[i].text, 30, true);
            let text:string = this.props.chapters[i].name;
            return text;
        // }
        return this.state.jumpStorySelected;
    }

    // private getCurrentChapterJump():string {
    //     return "Chapter " + (AppUtils.getChapterIndex(this.props, this.props.jumpPage) + 1);
    // }

    private getCurrentStoryJump():string {
        let jumpChapter = this.props.jumpChapter;
        let chapterIndex:number = AppUtils.getChapterIndex(this.props, jumpChapter)
        // console.log(this.props.chapters[chapterIndex], chapterIndex, jumpChapter)
        // console.log("Current story jump:", this.props.chapters[chapterIndex])

        if(this.props.chapters[chapterIndex] == null) {
            chapterIndex = 0; // default to the first chapter
        }

        let storys = this.props.chapters[chapterIndex].storys;
        let jumpStory = this.props.jumpPage;
        let storyIndex:number = AppUtils.getStoryIndex(this.props.chapters[chapterIndex], jumpStory)
        // if(storys[storyIndex] == null) {
        //     storyIndex = 0; // default to the first chapter
        // }
        let text:string = "Please Select";
        if (storys[storyIndex] != null) {
            let story:Story = this.props.chapters[chapterIndex].storys[storyIndex];
            let textDecoded = story.textDecoded; 
            if (textDecoded == null) {
                textDecoded = story.text;
            }
            text = this.truncateString(textDecoded, 30, true);
        }

        // text = ReactHtmlParser(text, {decodeEntities: false});

        return text;
    }

    private handleDecisionChange(e?:any) {
        this.setState({decisionText: e.target.value});
        let decisions:Array<any> = this.props.decisions
        decisions[AppUtils.getDecisionIndex(decisions, this.props, this.props.id)].decision = e.target.value;
        this.props.onDecisionsUpdated(decisions)
    }

    private handleLinkChange(e?:any) {
        this.setState({linkUrl: e.target.value});
        let decisions:Array<any> = this.props.decisions
        decisions[AppUtils.getDecisionIndex(decisions, this.props, this.props.id)].linkUrl = e.target.value;
        this.props.onDecisionsUpdated(decisions)
    }

    // private handleOutcomeSelect(eventKey: any, e: any) {
    //     // let storys:Array<any> = this.props.chapters[this.props.currentChapter].storys;
    //     let decisions:Array<any> = this.props.decisions
    //     decisions[AppUtils.getDecisionIndex(decisions,this.props, this.props.id)].outcome = e.target.text;
    //     // this.props.onStoryUpdated(storys);
    //     this.props.onDecisionsUpdated(decisions)
    // }

    private handleImpactSelect(eventKey: any, e: any) {
        // let storys:Array<any> = this.props.chapters[this.props.currentChapter].storys;
        let decisions:Array<any> = this.props.decisions
        if (parseInt(eventKey) < 5) {
            decisions[AppUtils.getDecisionIndex(decisions,this.props, this.props.id)].outcome = "Positive";
        } else if (parseInt(eventKey) < 10) {
            decisions[AppUtils.getDecisionIndex(decisions,this.props, this.props.id)].outcome = "Negative";
        } else {
            decisions[AppUtils.getDecisionIndex(decisions,this.props, this.props.id)].outcome = "None";
        }
        decisions[AppUtils.getDecisionIndex(decisions,this.props, this.props.id)].impact = e.target.text;
        // this.props.onStoryUpdated(storys);
        this.props.onDecisionsUpdated(decisions)
    }

    private handleJumpChapterSelect(eventKey: any, e: any) {
        // console.log(e.target.id, eventKey);
        // let storys:Array<any> = this.props.chapters[this.props.currentChapter].storys;
        let decisions:Array<any> = this.props.decisions

        let decisionIndex:number = AppUtils.getDecisionIndex(decisions,this.props, this.props.id)
        decisions[decisionIndex].jumpChapter = e.target.id;


        if (e.target.id == States.link || e.target.id == States.backAStep || e.target.id == States.gameOverSuccess || e.target.id == States.gameOverFail || e.target.id == States.restart) {
            // console.log("MATCHED! -", e.target.id, AppConfig.STATE_GAME_OVER_SUCCESS, AppConfig.STATE_GAME_OVER_FAIL, AppConfig.STATE_GAME_OVER_RESTART)
            decisions[decisionIndex].jumpPage = e.target.id;
        }

        if (e.target.id == States.backAStep) {
            decisions[decisionIndex].move = "Stay";
        }

        // console.log("Setting jump chapter: ", e.target.id, AppConfig.)
        // this.props.onStoryUpdated(storys);
        this.props.onDecisionsUpdated(decisions)
    }

    private handleJumpStorySelect(eventKey: any, e: any) {
        // let storys:Array<any> = this.props.chapters[this.props.currentChapter].storys; // TODO: UPDATE
        let decisions:Array<any> = this.props.decisions
        decisions[AppUtils.getDecisionIndex(decisions,this.props, this.props.id)].jumpPage = e.target.id;
        // console.log("Setting jump page: ", e.target.id)
        // this.props.onStoryUpdated(storys);
        this.props.onDecisionsUpdated(decisions)
    }

    private onPressDeleteDecision(e?:any) {
        // let storys:Array<any> = this.props.chapters[this.props.currentChapter].storys;
        let decisions:Array<any> = this.props.decisions
        let dIndex:number = AppUtils.getDecisionIndex(decisions,this.props, this.props.id);
        if (dIndex != -1) {
            decisions.splice(dIndex, 1);
            // this.props.onStoryUpdated(storys);
            this.props.onDecisionsUpdated(decisions)
        }
    }

    private canDelete():boolean {
        if (this.props.numberOfDecisions > 1) {
            return true;
        } else {
            return false;
        }
    }

    private truncateString(s:string, length:number, addElepsis:boolean = true):string {
        if (s.length > length) {
            s = s.substring(0,length);
            if (addElepsis) {
                s += "...";
            }
        }
        return s;
    }

    private getJumpChapter():any {
        if (this.props.jumpChapter == States.link || this.props.jumpChapter == States.backAStep || this.props.jumpChapter == States.gameOverSuccess || this.props.jumpChapter == States.nextChapter || this.props.jumpChapter == States.gameOverFail || this.props.jumpChapter == States.restart) {
            return this.props.jumpChapter
        }
        if (this.props.jumpChapter == null || this.props.chapters[AppUtils.getChapterIndex(this.props, this.props.jumpChapter)] == null) {
            return this.props.chapters[this.props.currentChapter]
        }
        return this.props.chapters[AppUtils.getChapterIndex(this.props, this.props.jumpChapter)]
    }

    private handleMoveSelect(eventKey: any, e: any) {
        // let storys:Array<any> = this.props.chapters[this.props.currentChapter].storys;
        let decisions:Array<any> = this.props.decisions
        if (parseInt(eventKey) == 1) {
            decisions[AppUtils.getDecisionIndex(decisions,this.props, this.props.id)].move = "Continue";
        } else if (parseInt(eventKey) == 2) {
            decisions[AppUtils.getDecisionIndex(decisions,this.props, this.props.id)].move = "Stay";
        }
        // this.props.onStoryUpdated(storys);
        this.props.onDecisionsUpdated(decisions)
    }

    private getMoveIcon():any {
        let icon = ic_directions_walk
        if (this.props.move == "Stay") {
            icon = man
        }
        return icon
    }

    private getImpactIcon():any {
        let icon = neutral
        if (this.props.outcome == "Positive") {
            switch (this.props.impact) {
                case "Tiny":
                    icon = cool2
                    break;
                case "Small":
                    icon = wink2
                    break;
                case "Medium":
                    icon = smile2
                    break;
                case "Large":
                    icon = happy2
                    break;
                case "Huge":
                    icon = grin2
                    break;
                default:
                    console.log("[DecisionComponent] Unknown positive impact: ", this.props.outcome, this.props.impact)
                    break;
            }
        } else if (this.props.outcome == "Negative") {
            switch (this.props.impact) {
                case "Tiny":
                    icon = tongue2
                    break;
                case "Small":
                    icon = sad2
                    break;
                case "Medium":
                    icon = crying2
                    break;
                case "Large":
                    icon = angry2
                    break;
                case "Huge":
                    icon = frustrated2
                    break;
                default:
                    console.log("[DecisionComponent] Unknown negative impact: ", this.props.outcome, this.props.impact)
                    break;
            }
        }
        return icon
    }

    private getOutcomeClassName():string {
        return "dropdownBtn decisionDropdown decisionOutcomeBtn " + this.props.outcome + this.props.impact
    }

    private getMoveClassName():string {
        return "dropdownBtn decisionDropdown decisionMoveBtn " + this.props.move
    }

    private getImpactTooltip():string {
        let tooltip:string = this.props.outcome;
        if (this.props.outcome == "Positive" || this.props.outcome == "Negative") {
            tooltip = tooltip + " " + this.props.impact;
        }
        return tooltip;
    }

    private getDropdownStory(story:Story):string {
        let ds:string = story.textDecoded;
        if (ds == null) {
            ds = story.text;
        }
        ds = this.truncateString(ds, 60, true);
        return ds;
    }

    render() {
        return (
            <FormGroup>
                <InputGroup>
                    <FormControl id={this.props.id.toString()} className='decisionInput' type="text" placeholder="Add a decision" value={this.state.decisionText} onChange={this.handleDecisionChange} />
                    <InputGroup.Addon className="decisionInputAddon">
                        <OverlayTrigger delay={AppConfig.TOOLTIP_DELAY} key={"tooltip"+this.props.id.toString()} placement="top"
                            overlay={
                                <Tooltip id={`tooltip-top`}>
                                    Chapter to jump to
                                </Tooltip>
                            }>
                            <DropdownButton
                                className="dropdownBtn decisionDropdown"
                                bsStyle={"default"}
                                title={this.getCurrentChapterJump()}
                                key={"btnKey1"}
                                id={`dropdown-basic-${1}`}
                                >
                                <MenuItem header>Jump to a chapter...</MenuItem>
                                {this.props.chapters.map((c:any, i:number) => <MenuItem id={c.id} key={c.id} title={c.text} onSelect={this.handleJumpChapterSelect.bind(this)}>{c.name}</MenuItem>)}
                                <MenuItem divider />
                                <MenuItem key={States.link} id={States.link} onSelect={this.handleJumpChapterSelect.bind(this)}>{States.link}</MenuItem>
                                <MenuItem key={States.backAStep} id={States.backAStep} onSelect={this.handleJumpChapterSelect.bind(this)}>{States.backAStep}</MenuItem>
                                <MenuItem key={States.restart} id={States.restart} onSelect={this.handleJumpChapterSelect.bind(this)}>{States.restart}</MenuItem>
                                <MenuItem key={States.gameOverSuccess} id={States.gameOverSuccess} onSelect={this.handleJumpChapterSelect.bind(this)}>{States.gameOverSuccess}</MenuItem>
                                <MenuItem key={States.gameOverFail} id={States.gameOverFail} onSelect={this.handleJumpChapterSelect.bind(this)}>{States.gameOverFail}</MenuItem>
                            </DropdownButton>
                        </OverlayTrigger>
                    </InputGroup.Addon>
                    {
                        this.getCurrentChapterJump() == States.link ?
                        <InputGroup.Addon className="decisionInputAddon decisionLinkInput">
                            <FormControl id={this.props.id.toString()} className='decisionInput' type="text" placeholder="Link to a website" value={this.state.linkUrl} onChange={this.handleLinkChange} />
                        </InputGroup.Addon> : null
                    }
                    {
                        this.getJumpChapter().storys != null ?
                        <InputGroup.Addon className="decisionInputAddon">
                            <OverlayTrigger delay={AppConfig.TOOLTIP_DELAY} key={"tooltip1"+this.props.id.toString()} placement="top"
                                overlay={
                                    <Tooltip id={`tooltip-top`}>
                                        Page to jump to
                                    </Tooltip>
                                }>
                                <DropdownButton
                                    className="dropdownBtn decisionDropdown"
                                    bsStyle={"default"}
                                    title={this.getCurrentStoryJump()}
                                    key={"btnKey1"}
                                    id={`dropdown-basic-${1}`}
                                    >
                                    <MenuItem header>{this.getCurrentChapterJump()}</MenuItem>
                                    {this.getJumpChapter().storys.map((c:Story, i:number) => <MenuItem id={c.id.toString()} key={c.id} title={c.text} onSelect={this.handleJumpStorySelect.bind(this)}>{this.getDropdownStory(c)}</MenuItem>)}
                                </DropdownButton>
                            </OverlayTrigger>
                        </InputGroup.Addon> : null
                    }
                    <InputGroup.Addon className="decisionInputAddon">
                        <OverlayTrigger delay={AppConfig.TOOLTIP_DELAY} key={"tooltip2"+this.props.id.toString()} placement="top"
                            overlay={
                                <Tooltip id={`tooltip-top`}>
                                    {this.getImpactTooltip()}
                                </Tooltip>
                            }>
                            <Dropdown className="dropdownBtn decisionDropdown" id="dropdown-custom-1">
                                <Dropdown.Toggle noCaret className={this.getOutcomeClassName()}>
                                <Icon size={20} icon={this.getImpactIcon()}/>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <MenuItem key="10" eventKey="10" onSelect={this.handleImpactSelect.bind(this)}>None</MenuItem>
                                    <MenuItem divider />
                                    <MenuItem header>Positive</MenuItem>
                                    <MenuItem key="0" selected={true} eventKey="0" onSelect={this.handleImpactSelect.bind(this)}>Tiny</MenuItem>
                                    <MenuItem key="1" eventKey="1" onSelect={this.handleImpactSelect.bind(this)}>Small</MenuItem>
                                    <MenuItem key="2" eventKey="2" onSelect={this.handleImpactSelect.bind(this)}>Medium</MenuItem>
                                    <MenuItem key="3" eventKey="3" onSelect={this.handleImpactSelect.bind(this)}>Large</MenuItem>
                                    <MenuItem key="4" eventKey="4" onSelect={this.handleImpactSelect.bind(this)}>Huge</MenuItem>
                                    <MenuItem divider />
                                    <MenuItem header>Negative</MenuItem>
                                    <MenuItem key="5" eventKey="5" onSelect={this.handleImpactSelect.bind(this)}>Tiny</MenuItem>
                                    <MenuItem key="6" eventKey="6" onSelect={this.handleImpactSelect.bind(this)}>Small</MenuItem>
                                    <MenuItem key="7" eventKey="7" onSelect={this.handleImpactSelect.bind(this)}>Medium</MenuItem>
                                    <MenuItem key="8" eventKey="8" onSelect={this.handleImpactSelect.bind(this)}>Large</MenuItem>
                                    <MenuItem key="9" eventKey="9" onSelect={this.handleImpactSelect.bind(this)}>Huge</MenuItem>
                                </Dropdown.Menu>
                            </Dropdown>
                        </OverlayTrigger>
                    </InputGroup.Addon>
                    {
                        this.getCurrentChapterJump() != States.backAStep || this.getCurrentChapterJump() != States.link || this.getCurrentChapterJump() != States.restart || this.getCurrentChapterJump() != States.gameOverFail || this.getCurrentChapterJump() != States.gameOverSuccess ?
                        <InputGroup.Addon className="decisionInputAddon">
                            <OverlayTrigger delay={AppConfig.TOOLTIP_DELAY} key={"tooltip3"+this.props.id.toString()} placement="top"
                                overlay={
                                    <Tooltip id={`tooltip-top`}>
                                        {this.props.move}
                                    </Tooltip>
                                }>
                                <Dropdown className="dropdownBtn decisionDropdown" id="dropdown-custom-1">
                                    <Dropdown.Toggle noCaret className={this.getMoveClassName()}>
                                        <Icon size={23} icon={this.getMoveIcon()}/>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <MenuItem key="1" eventKey="1" onSelect={this.handleMoveSelect.bind(this)}>Continue</MenuItem>
                                        <MenuItem key="2" eventKey="2" onSelect={this.handleMoveSelect.bind(this)}>Stay</MenuItem>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </OverlayTrigger>
                        </InputGroup.Addon> : null
                    }
                    {
                        this.canDelete() ?
                        <InputGroup.Addon className='decisionInputAddon deleteDecision' onClick={() => this.onPressDeleteDecision()}>
                            <OverlayTrigger delay={AppConfig.TOOLTIP_DELAY} key={"tooltip4"+this.props.id.toString()} placement="top"
                                overlay={
                                    <Tooltip id={`tooltip-top`}>
                                        Delete
                                    </Tooltip>
                                }>
                                <Glyphicon glyph="trash" />
                            </OverlayTrigger>
                        </InputGroup.Addon> : null
                    }
                </InputGroup>  
            </FormGroup>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/storyEditComponent/DecisionComponent.tsx